module.exports = __webpack_public_path__ + "img/33.2685254d.png";